import React from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

const Landing = () => {
  return (
    <div className="landing">
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Building the Future,
              <br />
              <span style={{ opacity: 0.95 }}>One Line of Code at a Time</span>
            </h1>
            <p className="hero-subtitle">
              Strebla Innovations - Where creativity meets technology.
              We craft beautiful software solutions that make a difference.
            </p>
            <div className="hero-buttons">
              <Link to="/products" className="btn btn-primary">
                Explore Our Products
              </Link>
              <Link to="/about" className="btn btn-secondary">
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="features section">
        <div className="container">
          <h2 className="section-title">What We Do</h2>
          <p className="section-subtitle">
            We specialize in creating innovative software solutions and beautiful designs
          </p>
          <div className="features-grid">
            <div className="feature-card card">
              <div className="feature-icon">💻</div>
              <h3>Software Development</h3>
              <p>
                Custom software solutions tailored to your needs. From web applications
                to mobile apps, we bring your ideas to life.
              </p>
            </div>
            <div className="feature-card card">
              <div className="feature-icon">🎨</div>
              <h3>Design & UX</h3>
              <p>
                Beautiful, intuitive interfaces that users love. We focus on creating
                experiences that are both functional and delightful.
              </p>
            </div>
            <div className="feature-card card">
              <div className="feature-icon">🚀</div>
              <h3>Innovation</h3>
              <p>
                Pushing boundaries and exploring new technologies. We're always learning,
                always building, always innovating.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Landing;

